export var checkFallbackFn = function (fallback) {
    return fallback && typeof fallback === 'function';
};
